'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var locale = 'fr';
  var routes = [{
    paths: { fr: ['/evenements'], en: ['/events'] },
    component: _containers.EventsContainer
  }, {
    paths: { fr: ['/evenements/:slug/:id'], en: ['/events/:slug/:id'] },
    component: _containers.EventPageContainer
  }, {
    paths: { fr: ['/a-propos'], en: ['/about'] },
    component: _components.About
  }, {
    paths: { fr: ['/types'], en: ['/types'] },
    component: _containers.TypesContainer
  }, {
    paths: { fr: ['/themes'], en: ['/themes'] },
    component: _containers.TagsContainer
  }, {
    paths: { fr: ['/lieux'], en: ['/venues'] },
    component: _containers.VenuesContainer
  }, {
    paths: { fr: ['/groupes'], en: ['/groups'] },
    component: _containers.OrganizationsContainer
  }, {
    paths: { fr: ['/a-propos'], en: ['/about'] },
    component: _components.About
  }];

  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.AppContainer },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.HomeContainer }),
    routes.map(function (route, index) {
      return _react2.default.createElement(
        _reactRouter.Route,
        { key: index, component: route.component },
        route.paths[locale].map(function (path, ind) {
          return _react2.default.createElement(_reactRouter.Route, { key: ind, path: path });
        })
      );
    }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _components.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1202
// module chunks = 0